export const configMap = {
  // 开发
  development: {
    rootPath: 'https://app-api-test2.yayya.live',
    realEnv: 'development',
    host: '',
    hobyWebHost: 'https://h5-activity-test.yayya.live', // 旧项目host地址
    hobyWebHostRu: 'https://h5-activity-test.yayya.live', // 旧项目host地址（因为s3域名解析问题，俄罗斯使用单独的域名）
  },
  // 测试
  testing: {
    rootPath: 'https://app-api-test2.yayya.live',
    realEnv: 'testing',
    host: '',
    hobyWebHost: 'https://h5-activity-test.yayya.live', // 旧项目host地址
    hobyWebHostRu: 'https://h5-activity-test.yayya.live', // 旧项目host地址（因为s3域名解析问题，俄罗斯使用单独的域名）
  },
  // 灰度
  uat: {
    rootPath: 'https://app-api-uat.yayya.live',
    realEnv: 'uat',
    host: '',
    hobyWebHost: 'https://h5-activity-uat.yayya.live', // 旧项目host地址
    hobyWebHostRu: 'https://h5-activity-uat.yayya.live', // 旧项目host地址（因为s3域名解析问题，俄罗斯使用单独的域名）
  },
  production: {
    rootPath: 'https://app-api.yayya.live',
    realEnv: 'production',
    host: '',
    hobyWebHost: 'https://h5-activity.yayya.live', // 旧项目host地址
    hobyWebHostRu: 'https://h5-activity.yayya.live', // 旧项目host地址（因为s3域名解析问题，俄罗斯使用单独的域名）
  },
  // vocaChat 环境
  // test 环境
  vocaTesting: {
    rootPath: '',
    realEnv: 'vocaTesting',
    host: '',
    hobyWebHost: '', // 旧项目host地址
  },
  vocaProd: {
    rootPath: '',
    realEnv: 'vocaProd',
    host: '',
    hobyWebHost: '', // 旧项目host地址
  },
}

type Environment = 'development' | 'testing' | 'uat' | 'production'
const NODE_ENV: Environment = import.meta.env.MODE as Environment

export function getConfig(env?: 'development' | 'testing' | 'uat' | 'production') {
  const config = configMap[env || NODE_ENV] || configMap['production']
  const defaultConfig = {
    language: 'en',
    designWidth: 375,
    projectName: 'hybrid',
    contactServiceTel: '+44 7707115144',
    rootPathRu: 'https://api.hobychat.ru', // 因为s3域名解析问题，俄罗斯使用单独的域名
  }

  return Object.assign(defaultConfig, config)
}
